export default __webpack_public_path__ + "static/media/parang-min.db309cf9.png";